import { action } from 'typesafe-actions'
import { Image } from '@models/image'
import {RequestData} from "@models/axios";



export const enum ImagesActionTypes {
    FETCH_REQUEST = '@@images/FETCH_REQUEST',
    FETCH_SUCCESS = '@@images/FETCH_SUCCESS',
    FETCH_ERROR = '@@images/FETCH_ERROR',

    CREATE_REQUEST = '@@images/CREATE_REQUEST',
    CREATE_SUCCESS = '@@images/CREATE_SUCCESS',
    CREATE_ERROR = '@@images/CREATE_ERROR',

    DELETE_REQUEST = '@@images/DELETE_REQUEST',
    DELETE_SUCCESS = '@@images/DELETE_SUCCESS',
    DELETE_ERROR = '@@images/DELETE_ERROR',

    UPDATE_REQUEST = '@@images/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@images/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@images/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@images/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@images/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@images/FETCH_ITEM_ERROR',
}



export const fetchRequest = (data:RequestData) => action(ImagesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Image[]) => action(ImagesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(ImagesActionTypes.FETCH_ERROR, message);


export const createRequest = (data:RequestData) => action(ImagesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Image[]) => action(ImagesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(ImagesActionTypes.CREATE_ERROR, message);


export const deleteRequest = (data:RequestData) => action(ImagesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(ImagesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(ImagesActionTypes.DELETE_ERROR, message);


export const updateRequest = (data:RequestData) => action(ImagesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Image[]) => action(ImagesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(ImagesActionTypes.UPDATE_ERROR, message);


export const fetchItemRequest = (data:RequestData) => action(ImagesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Image[]) => action(ImagesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(ImagesActionTypes.FETCH_ITEM_ERROR, message);